import React, { Component } from "react";
import { ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import { connect } from "react-redux";
import * as actions from "../../stores/actions/index";
import { translate } from "react-i18next";

class DeleteUser extends Component {
  submitModal = () => {
    const { deleteUser, modalData, deleteProfile } = this.props;
    const { id, component } = modalData;
    component === "alertProfile" ? deleteProfile(id) : deleteUser({ id: id });
  };

  render() {
    const { toggleModal, modalData, t } = this.props;
    const { component } = modalData;

    return (
      <React.Fragment>
        <ModalHeader toggle={toggleModal}>{` ${t("dashboard.delete")} ${
          component === "alertProfile"
            ? t("dashboard.profile")
            : t("dashboard.user")
        }`}</ModalHeader>
        <ModalBody>
          <div className="d-flex flex-column align-items-center">
            <i
              className="fas fa-question-circle text-warning display-4"
              style={{ fontWeight: 900 }}
            ></i>
            <p className="text-warning">{t("dashboard.warning")}!</p>
            <p className="px-3 text-center">
              {t("dashboard.areYouSureYouWantToPRT")}{" "}
              {component === "alertProfile"
                ? t("dashboard.profile")
                : t("dashboard.user")}
              ? <br /> {t("dashboard.pleaseNoteThereAreCurrentlyActive")}{" "}
              {component === "alertProfile"
                ? t("dashboard.profile")
                : t("dashboard.alarms")}
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="info" onClick={this.submitModal}>
            {t("dashboard.confirm")}
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            {t("dashboard.cancel")}
          </Button>
        </ModalFooter>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteUser: (data) => dispatch(actions.deleteUser(data)),
    deleteProfile: (data) => dispatch(actions.deleteProfile(data)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(translate("translations")(DeleteUser));
